/***
 * @file:
 * @author: linkun.he
 * @Date: 2019-09-18 14:20:58
 */
import { TemplateRef, Type } from '@angular/core';

// tslint:disable-next-line:no-any
export function isNotNil(value: any): boolean {
  return typeof value !== 'undefined' && value !== null;
}

// tslint:disable-next-line:no-any
export function isNil(value: any): value is null | undefined {
  return typeof value === 'undefined' || value === null;
}

export function isInteger(value: string | number): boolean {
  return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
}

// tslint:disable-next-line:no-any
export function isTemplateRef(value: any): boolean {
  return value instanceof TemplateRef;
}

// tslint:disable-next-line:no-any
export function isComponent(value: any): boolean {
  return value instanceof Type;
}
